/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-floating-promises, @typescript-eslint/no-explicit-any */

import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import { SGTooltip } from '../core';
import { downloadChartAsPng } from '../../util/shared';

interface DownloadChartButtonProps {
  chartRef: any;
  selectedSym: string;
  chartName: string;
  description?: string;
}

export const DownloadChartButton = ({
  chartRef,
  selectedSym,
  chartName,
  description,
}: DownloadChartButtonProps) => {
  const theme = useTheme();

  return (
    <IconButton
      className="canvas-no-drag"
      aria-label="download-chart"
      color="primary"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        downloadChartAsPng(chartRef, `${selectedSym}-${chartName}`, {
          backgroundColor: theme.palette.background.paper,
        });
      }}
    >
      <SGTooltip title={description ?? 'Download Chart'}>
        <DownloadIcon />
      </SGTooltip>
    </IconButton>
  );
};
